
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore } from "@/store/store-accessor";
import ToggleInput from "@/components/Reusable/CustomInputs/ToggleInput.vue";

@Component({
  components: { ToggleInput }
})
export default class BuilderBehaviorInput extends Vue {
  get value() {
    return uiStore.builderBehaviorElementId === uiStore.activeElementId;
  }

  edit(enabled: boolean) {
    const newId = enabled ? uiStore.activeElementId : null;
    uiStore.setBuilderBehaviorElementId(newId);
  }
}
